module.exports = __webpack_public_path__ + "assets/img/showroom.d680161a.svg";